var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/_core.js
// module id = 235
// module chunks = 0